<template>
<div class="main">

    <!--hero section start-->
    <section class="hero-section ptb-100 background-img full-screen" style="background: url('./static/img/hero-bg-.jpg')no-repeat center center / cover">
        <div class="container">
            <div class="row align-items-center justify-content-center">
                <div class="col-md-9 col-lg-7">
                    <div class="error-content text-center text-white">
                        <div class="notfound-404">
                            <h1 class="text-white">404</h1>
                        </div>
                        <h3 class="text-white">Ups!, lo sentimos</h3>
                        <p>Ya finalizaron las inscripciones del mes.</p>
                        <a class="btn app-store-btn" @click="back">Volver</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--hero section end-->

</div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    methods: {
        back() {
            this.$router.push({
                path: `/`
            })
        }
    }

}
</script>



// WEBPACK FOOTER //
// src/components/pages/errors/not-available.vue